import { TFunction } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { IntroDataProps } from './Insights.types';

export const INSIGHTSDATA = (
  t: TFunction,
  locale: string | undefined
): IntroDataProps[] => [
  {
    image: getPublicPath(`/images/stateSector/2024/insights-summary.png`),
    title: t('mantechcar24.insights.summary-title'),
    text: t('mantechcar24.insights.summary-desc'),
    url_es: 'https://www.getmanfred.com/blog/tech-career-report-resumen-2024',
    url_en: 'https://www.getmanfred.com/en/blog/tech-career-report-resumen-2024'
  },
  {
    image: getPublicPath(`/images/stateSector/2024/insights-hybrid.png`),
    title: t('mantechcar24.insights.hybrid-title'),
    text: t('mantechcar24.insights.hybrid-desc'),
    url_es: 'https://www.getmanfred.com/blog/la-vuelta-al-hibrido',
    url_en: 'https://www.getmanfred.com/en/blog/la-vuelta-al-hibrido'
  },
  {
    image: getPublicPath(`/images/stateSector/2024/insights-salaries.png`),
    title: t('mantechcar24.insights.salaries-title'),
    text: t('mantechcar24.insights.salaries-desc'),
    url_es: 'https://www.getmanfred.com/blog/tech-career-report-alarios',
    url_en: 'https://www.getmanfred.com/en/blog/tech-career-report-alarios'
  },
  {
    image: getPublicPath(`/images/stateSector/2024/insights-soft-skills.png`),
    title: t('mantechcar24.insights.soft-skills-title'),
    text: t('mantechcar24.insights.soft-skills-desc'),
    url_es: 'https://www.getmanfred.com/blog/las-soft-skills-olvidadas',
    url_en: 'https://www.getmanfred.com/en/blog/las-soft-skills-olvidadas'
  },
  {
    image: getPublicPath(`/images/stateSector/2024/insights-ia.png`),
    title: t('mantechcar24.insights.ia-title'),
    text: t('mantechcar24.insights.ia-desc'),
    url_es: 'https://www.getmanfred.com/blog/el-auge-de-la-ia',
    url_en: 'https://www.getmanfred.com/en/blog/el-auge-de-la-ia'
  }
];
